export default { version: '7.4.5' };
